// lib
import { styled } from '@nykaa/ui-components';

// constants
import { BASE_GUTTER_SPACE } from 'shared/styles/base';

// components
import BaseOverlaySheet from 'shared/components/OverlaySheet';

export const FixedContent = styled.div`
  width: 30%;
  max-width: 400px;
  height: 100%;
  overflow-y: auto;
  position: fixed;
  right: 0;
  background: white;
  box-shadow: 0px -${BASE_GUTTER_SPACE}px ${BASE_GUTTER_SPACE}px ${({ theme }) => theme.colors.textOutline};
  z-index: 7;
`;

export const Wrapper = styled.div`
  position: relative;
  height: 100%;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing100}`};
`;

export const IconContainer = styled.span`
  cursor: pointer;
  position: absolute;
  right: 30px;
  top: 4px;
`;

export const OverlaySheet = styled(BaseOverlaySheet)`
  top: 0;
  left: 70%;
  height: 100%;
  width: 30%;
  max-width: 400px;
  overflow: hidden;
  background: transparent;
  color: #000;
  border-radius: ${({ theme }) => theme.borders.radiusNone};
`;
